import React from 'react'
import { Toolbar } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%',
    width: '100%',
    backgroundColor: '#fff',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
  },
}))

const LargeToolbar = ({ content, right }) => {
  const classes = useStyle()
  return (
    <Toolbar className={classes.root}>
      <div className={classes.item}>{content}</div>
      {right && <div className={classes.item}>{right}</div>}
    </Toolbar>
  )
}

export default LargeToolbar
